import { render } from "./formStock.vue?vue&type=template&id=3f83c69e&scoped=true"
import script from "./formStock.vue?vue&type=script&lang=js"
export * from "./formStock.vue?vue&type=script&lang=js"

import "./formStock.vue?vue&type=style&index=0&id=3f83c69e&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f83c69e"]])

export default __exports__